import React, {
  memo,
  useState
  // , useEffect
} from 'react';
import {
  Row,
  Col,
  Input,
  Button,
  Select,
  message
  // Option
} from 'antd';

import {
  getSmsNotifications,
  getEmailNotifications
} from '../actions/sessionActions';
const Notification = data => {
  const [filter, setFilter] = useState({
    key: null,
    enterprise_id: null,
    awb: ''
  });

  const [gridData, setGridData] = useState({
    sms: [],
    email: []
  });

  const search = () => {
    if (filter?.awb?.trim() === '') {
      return message.error('Please enter text in search input');
    }
    Promise.all([
      getSmsNotifications(filter.awb, filter.enterprise_id),
      getEmailNotifications(filter.awb, filter.enterprise_id)
    ]).then(results => {
      if (
        results[0].meta.status === 200 &&
        results[0].meta.data.length === 0 &&
        results[1].meta.status === 200 &&
        results[1].meta.data.length === 0
      ) {
        message.info(`${results[0].meta.message}, ${results[1].meta.message}`);
      } else if (
        results[0].meta.status === 200 ||
        results[1].meta.status === 200
      ) {
        setGridData({
          ...gridData,
          sms: results[0].meta.data,
          email: results[1].meta.data
        });
      }
    });
  };

  return (
    <div>
      <Row className="margin-bottom-10">
        <Col span={8}>
          <div className="global-search-wrapper width-100">
            <Select
              showSearch
              className="width-100"
              placeholder="Select enterprise"
              optionFilterProp="children"
              // value=
              onChange={evt => {
                setFilter({
                  ...filter,
                  enterprise_id: evt
                });
              }}
              allowClear={true}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {data.EnterpriseData.enterprise.list.map((enterprise, i) => (
                <Select.Option key={i} value={enterprise.id}>
                  {enterprise.name}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
        <Col span={12}>
          <div className="global-search-wrapper width-100 margin-lr-8">
            <Input
              name="scan"
              placeholder={`AWB Number`}
              className="ant-input"
              onChange={evt => {
                setFilter({
                  ...filter,
                  awb: evt.target.value
                });
              }}
            />
          </div>
        </Col>
        <Col span={4} className="text-right">
          <Button
            type="primary"
            className="margin-lr-8"
            onClick={() => search()}
          >
            Search
          </Button>
        </Col>
      </Row>
      {gridData.email.length === 0 ? (
        ''
      ) : (
        <div>
          <Row className="title margin-top-20">EMAIL</Row>
          <Row>
            <table className={`ant-table ant-table-small width-100pt`}>
              <thead className="ant-table-thead">
                <tr>
                  <th>Gateway</th>
                  <th>Shipment Status</th>
                  <th>Sent at timestamp</th>
                  <th>Sent Status </th>
                  <th>Failure Reason</th>
                </tr>
              </thead>
              <tbody className="ant-table-tbody">
                {gridData.email.map((value, index) => (
                  <tr key={index}>
                    <td key={value.Gateway} className="padding-16">
                      {value.Gateway}
                    </td>
                    <td key={value.ShipmentStatus} className="padding-16">
                      {value.ShipmentStatus}
                    </td>
                    <td key={value.SentTimestamp} className="padding-16">
                      {value.SentTimestamp}
                    </td>
                    <td key={value.Success} className="padding-16">
                      {String(value.Success)}
                    </td>
                    <td key={value.FailureReason} className="padding-16">
                      {String(value.FailureReason)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Row>{' '}
        </div>
      )}

      {gridData.sms.length === 0 ? (
        ''
      ) : (
        <div>
          <Row className="title margin-top-20">SMS</Row>
          <Row>
            <table className={`ant-table ant-table-small width-100pt`}>
              <thead className="ant-table-thead">
                <tr>
                  <th>Gateway</th>
                  <th>Shipment Status</th>
                  <th>Sent at timestamp</th>
                  <th>Sent Status </th>
                  <th>Failure Reason</th>
                </tr>
              </thead>
              <tbody className="ant-table-tbody">
                {gridData.sms.map((value, index) => (
                  <tr key={index}>
                    <td key={value.Gateway} className="padding-16">
                      {value.Gateway}
                    </td>
                    <td key={value.ShipmentStatus} className="padding-16">
                      {value.ShipmentStatus}
                    </td>
                    <td key={value.SentTimestamp} className="padding-16">
                      {value.SentTimestamp}
                    </td>
                    <td key={value.Success} className="padding-16">
                      {String(value.Success)}
                    </td>
                    <td key={value.FailureReason} className="padding-16">
                      {String(value.FailureReason)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Row>
        </div>
      )}
    </div>
  );
};

export default memo(Notification);
